import { t } from '@/i18n';

/**
 * Etiquetas de estatus de tarjeta (BF-623/BF-630). El BE puede devolver
 * `enabled`/`disabled` (valores crudos de la tarjeta) o `active`/`inactive`
 * (valores normalizados); ambos se muestran como Activa/Inactiva.
 */
const CARD_STATUS_LABEL_KEYS: Record<string, string> = {
  active: 'dashboard.card.status.active',
  enabled: 'dashboard.card.status.active',
  blocked: 'dashboard.card.status.blocked',
  inactive: 'dashboard.card.status.inactive',
  disabled: 'dashboard.card.status.inactive',
  cancelled: 'dashboard.card.status.inactive',
  canceled: 'dashboard.card.status.inactive',
};

export function cardStatusLabel(value: string): string {
  const key = CARD_STATUS_LABEL_KEYS[value];
  return key ? t(key) : value;
}
